import React, { useState } from 'react';
import { Home } from 'react-feather';
import { Link } from 'react-router-dom';
import { Container, Row, Breadcrumb, BreadcrumbItem, Col, Card, CardBody, Collapse } from 'reactstrap';

export default function OurStack() {
    const [isOpen, setIsOpen] = useState('')
    const stacks = [
        {
            id: 1,
            stack: 'Resque',
            links: [
                {
                    label: 'https://resque-web1.promptcloud.com/workers',
                    value: 'https://resque-web1.promptcloud.com/workers'
                },
                {
                    label: 'https://resque-web-ror.promptcloud.com/workers',
                    value: 'https://resque-web-ror.promptcloud.com/workers'
                }
            ]
        },
        {
            id: 2,
            stack: 'RabbitMQ',
            links: [
                {
                    label: 'https://cl1-queue1.promptcloud.com/',
                    value: 'https://cl1-queue1.promptcloud.com/'
                },
                {
                    label: 'https://cl1-queue2.promptcloud.com/',
                    value: 'https://cl1-queue2.promptcloud.com/'
                },
                {
                    label: 'https://cl2-queue1.promptcloud.com/',
                    value: 'https://cl1-queue1.promptcloud.com/'
                },
                {
                    label: 'https://cl2-queue2.promptcloud.com/',
                    value: 'https://cl2-queue2.promptcloud.com/'
                }
            ]
        },
        {
            id: 3,
            stack: 'Kibana',
            links: [
                {
                    label: 'https://kibanav8-plm.promptcloud.com/',
                    value: 'https://kibanav8-plm.promptcloud.com/'
                },
                {
                    label: 'https://kibanajp-internal.promptcloud.com/',
                    value: 'https://kibanajp-internal.promptcloud.com/'
                },
                {
                    label: 'https://kibanav8-be.promptcloud.com/',
                    value: 'https://kibanav8-be.promptcloud.com/'
                },
                {
                    label: 'https://kibanav8-42signals.promptcloud.com/',
                    value: 'https://kibanav8-42signals.promptcloud.com/'
                }
            ]
        },
        {
            id: 4,
            stack: 'Jenkins',
            links: [
                {
                    label: 'https://ci.promptcloud.com/',
                    value: 'https://ci.promptcloud.com/',

                }
            ]
        },
        {
            id: 5,
            stack: 'HA Proxy',
            links: [
                {
                    label: 'ha.promptcloud.com',
                    value: 'ha.promptcloud.com',

                },
                {
                    label: 'ha-secondary.promptcloud.com',
                    value: 'ha-secondary.promptcloud.com',

                },
                {
                    label: 'ha-2a.promptcloud.com',
                    value: 'ha-2a.promptcloud.com',

                },
                {
                    label: 'ha-2b.promptcloud.com',
                    value: 'ha-2b.promptcloud.com',

                },
            ]
        },
        {
            id: 6,
            stack: 'PromptCloud API',
            links: [
                {
                    label: 'https://api.promptcloud.com/v2/data/info?type=help',
                    value: 'https://api.promptcloud.com/v2/data/info?type=help'
                }
            ]
        },
        {
            id: 7,
            stack: 'PromptCloud Search',
            links: [
                {
                    label: 'http://premium.search.promptcloud.com/api/v1/search?type=help',
                    value: 'http://premium.search.promptcloud.com/api/v1/search?type=help'
                },
                {
                    label: 'http://search.promptcloud.com/api/v1/search?type=help',
                    value: 'http://search.promptcloud.com/api/v1/search?type=help'
                }
            ]
        },
        {
            id: 8,
            stack: 'Redmine',
            links: [
                {
                    label: 'https://tickets.promptcloud.com/',
                    value: 'https://tickets.promptcloud.com/'
                }
            ]
        },
        {
            id: 9,
            stack: 'Github',
            links: [
                {
                    label: 'https://github.com/promptcloud-private-repos',
                    value: 'https://github.com/promptcloud-private-repos',

                }
            ]
        },
        {
            id: 10,
            stack: 'CrawlBoard App',
            links: [
                {
                    label: 'https://app.promptcloud.com/',
                    value: 'https://app.promptcloud.com/'
                },
                {
                    label: 'https://app.bcp.promptcloud.com/ (Non-functional)',
                    value: 'https://app.bcp.promptcloud.com/'
                }
            ]
        },
        {
            id: 11,
            stack: 'Internal Dashboard',
            links: [
                {
                    label: 'https://app.promptcloud.com/internal',
                    value: 'https://app.promptcloud.com/internal'
                },
                {
                    label: 'https://app.bcp.promptcloud.com/internal (Non-functional)',
                    value: 'https://app.bcp.promptcloud.com/internal'
                }
            ]
        },
        {
            id: 12,
            stack: 'Zabbix',
            links: [
                {
                    label: 'https://zabbixmon.promptcloud.com/',
                    value: 'https://zabbixmon.promptcloud.com/'
                }
            ]
        }
    ];
    let count=0;
    return <Container fluid>
        <div className="page-title">
            <Row>
                <Col xs="6">
                    <h3> Internal Dashboard</h3>
                </Col>
                <Col xs="6">
                    <Breadcrumb>
                        <BreadcrumbItem>
                            <Link to={'/internal'}>
                                <Home />
                            </Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem className="fw-bold">
                            PromptCloud Stack
                        </BreadcrumbItem>
                    </Breadcrumb>
                </Col>
            </Row>
        </div>
        <Card>
            <CardBody>
                {
                    stacks.map(item => {
                        return <div style={{ cursor: "pointer" }} key={item.id}>
                            <div className="w-100 p-3 fw-bold text-start mt-2 panel-heading" role={'presentation'} onClick={() => {
                                setIsOpen(isOpen == item.id ? '' : item.id)
                            }}>
                            {item.stack}

                            </div>
                            <Collapse className='panel-body' isOpen={isOpen == item.id}>
                                {item.links.map(link => {
                                    
                                    return <div className={item.links[0].label == link.label ? 'fw-bold' : ''}>
                                        <a href={link.value} target='_blank' className='link-primary'>{link.label}</a>
                                    </div>
                                })}
                            </Collapse>
                        </div>
                    })
                }
            </CardBody>
        </Card>
    </Container>
}